import { Close } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  IconButton,
  ListItemButton,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback.jsx";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import Loader from "../../common/Loader.jsx";
import { FETCH_USERS_WORK_HISTORY } from "../../constant/Apipath.jsx";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import { getFormattedAddress } from "../common/GetFormattedAddress";

export default function SiteListForBuySell(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [experienceData, setExperienceData] = useState([]);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  // Language data
  const LanguageData = multiLanguageData?.BuySell || {};
  const {
    TEXT_CHOOSE_SITE_HEADER = English.BuySell.TEXT_CHOOSE_SITE_HEADER,
    TEXT_NO_SITES_FOUND = English.BuySell.TEXT_NO_SITES_FOUND,
    TEXT_SITE_FOOTER_HINT = English.BuySell.TEXT_SITE_FOOTER_HINT
  } = LanguageData;
  let currentUserId = loginData?.userInformation?.UserId ?? 0;

  useEffect(() => {
    getUserSites();
  }, []);

  const removeDuplicates = (originalArray, prop) => {
    let newArray = [];
    let lookupObject = {};
    for (let i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for (let i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  };

  const getUserSites = async () => {
    setIsLoading(true);
    try {
      const workHistoryObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 0,
        SearchList: [{ UserId: Number(currentUserId) }]
      };
      let userSitesRes = await Postrequestcall(
        FETCH_USERS_WORK_HISTORY,
        workHistoryObj,
        loginData?.accessToken
      );
      let userSitesResData = userSitesRes?.data?.data ?? [];
      let updatedUserSitesData = removeDuplicates(userSitesResData, "siteId");
      const finalCompSites = [...updatedUserSitesData];
      setExperienceData(finalCompSites ?? []);
      setIsLoading(false);
    } catch (e) {
      console.log("getUserSites -> Error When getting User Sites: ", e);
      setIsLoading(false);
    }
  };

  const getAddress = (params) => {
    const userAddress = {
      city: params?.city,
      country: params?.country,
      province: params?.province,
      postalCode: params?.postalCode,
      address: params?.address
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
          /\w*/g,
          (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };
  return (
    <>
      <Modal open={props?.isOpen} onClose={props?.onClose}>
        <Box
          className="user-modal-responsive"
          sx={{
            borderRadius: "24px",
            p: 0,
            overflow: "hidden",
            bgcolor: "white",
            maxWidth: "500px !important",
            outline: "none"
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2.5,
              borderBottom: "1px solid #f1f5f9"
            }}
          >
            <Typography variant="h6" fontWeight={700}>{TEXT_CHOOSE_SITE_HEADER}</Typography>
            <IconButton onClick={() => props?.onClose()} size="small">
              <Close />
            </IconButton>
          </Box>

          <Box
            sx={{
              maxHeight: "60vh",
              overflowY: "auto",
              p: 2,
              bgcolor: "#f8fafc"
            }}
          >
            {isLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 10 }}>
                <Loader />
              </Box>
            ) : experienceData?.length === 0 ? (
              <Box sx={{ textAlign: "center", py: 5 }}>
                <Typography color="text.secondary">{TEXT_NO_SITES_FOUND}</Typography>
              </Box>
            ) : (
              <Stack spacing={1.5}>
                {experienceData?.map((item, index) => (
                  <Card
                    key={item.siteId || index}
                    sx={{
                      borderRadius: "16px",
                      border: "1px solid #e2e8f0",
                      boxShadow: "none",
                      transition: "all 0.2s",
                      "&:hover": {
                        borderColor: "#3b82f6",
                        bgcolor: "white",
                        transform: "translateY(-2px)",
                        boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)"
                      }
                    }}
                  >
                    <ListItemButton
                      sx={{ p: 1.5, borderRadius: "16px" }}
                      onClick={() => {
                        props?.onSelectSite(item);
                        props?.onClose();
                      }}
                    >
                      <Avatar
                        variant="rounded"
                        src={item?.mainPictureUrl || defaultProjectImage}
                        sx={{ width: 64, height: 64, borderRadius: "12px" }}
                      />
                      <Box sx={{ ml: 2 }}>
                        <Typography variant="subtitle1" fontWeight={700} color="#1e293b">
                          {item?.siteName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                          {getAddress(item)}
                        </Typography>
                      </Box>
                    </ListItemButton>
                  </Card>
                ))}
              </Stack>
            )}
          </Box>

          <Box sx={{ p: 2, borderTop: "1px solid #f1f5f9", textAlign: "center" }}>
            <Typography variant="caption" color="text.secondary">
              {TEXT_SITE_FOOTER_HINT}
            </Typography>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
